import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetByUserId } from '../../service/EpinPurchaseService';
import { GetByUserId as GetUserReferByUserId } from '../../service/UserReferService';


export default function EpinPurchaseList() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode, appUser
  } = useGlobalContext();

  const id = appUser.id;
  const [epinPurchases, setEpinPurchases] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [sponsor, setSponsor] = useState({ name: '-', mobile: '-' });


  const fetchEpinPurchaseList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByUserId(id, currentPage, limit, keyword);
      setEpinPurchases(response.epinPurchases || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEpinPurchaseList(page);
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchEpinPurchaseList(1);
  };

  useEffect(() => {
    const fetchSponsor = async () => {
      try {
        const response = await GetUserReferByUserId(id, 1, 1, "");
        const refer = response?.userRefers?.[0]?.referUser;
        if (refer) {
          setSponsor({
            name: refer.name || '-',
            mobile: refer.mobile || '-',
          });
        }
      } catch (error) {
        console.error("Failed to fetch sponsor info", error);
      }
    };

    if (id) fetchSponsor();
  }, [id]);


  return (
    <>
      <Helmet>
        <title>Epin Purchase List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>My Epin Purchase List</h1>
            <span><Link to="/"> Dashboard </Link> / My Epin Purchase List</span>
          </div>
          <div className='page-heading pt-0'>
            <h1 style={{ fontSize: '20px' }}>
              🔔 "For help, contact your promoter: {sponsor.name} ( {sponsor.mobile} )"
            </h1>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='table-content'>
                  <div className="mobile-scroll">
                    <table className='table table-bordered table-condensed'>
                      <thead>
                        <tr>
                          <th>Sl.no</th>
                          <th>Purchase date</th>
                          <th>Price</th>
                          <th>Unit</th>
                          <th>Level</th>
                          <th>Remarks</th>
                          <th>Total</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {epinPurchases && epinPurchases.length > 0 ? (
                          epinPurchases.map(({ epinPurchase, total }, index) => (
                            <tr key={epinPurchase.id}>
                              <td>{(page - 1) * limit + index + 1}</td>
                              <td>
                                {epinPurchase.purchaseDate?.date && (() => {
                                  const date = new Date(epinPurchase.purchaseDate.date);
                                  const day = String(date.getDate()).padStart(2, '0');
                                  const month = String(date.getMonth() + 1).padStart(2, '0');
                                  const year = date.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()}
                              </td>
                              <td>{epinPurchase.price}</td>
                              <td>{epinPurchase.unit}</td>
                              <td>{epinPurchase.level?.name ?? ''}</td>
                              <td>{epinPurchase.remarks}</td>
                              <td>{total}</td>
                              <td>{epinPurchase.status}</td>
                              <td>
                                <Link to={`/epin/list/${epinPurchase.id}`} className='btn btn-sm btn-warning' title="View Epin">
                                  <FontAwesomeIcon icon="fa-solid fa-eye" />
                                </Link>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="10" className="text-center">No purchases found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
